module.exports = __webpack_public_path__ + "static/cosi8-8804109ea279313d68b317dcf703eeab.jpg";